module.exports = "<section class=\"container-fluid \">\r\n  <app-artist></app-artist>\r\n</section>\r\n\r\n"